const InventoryReceipts = () => import("Modules/supply_chain/purchase_orders/views/InventoryReceipts");
const InventoryReceiptsForm = () => import("Modules/supply_chain/purchase_orders/views/InventoryReceiptsForm");

export default {
    children: [
        {
            path: "purchasing/inventory_receipts",
            name: "inventory_receipts",
            component: InventoryReceipts,
            meta: {
                requiresAuth: true,
                title: "lang.inventory_receipts",
                restrict_by_login_type: ["employee", "customer"],
                restrict_by_permission: ["inventory_receipts.read"],
            },
        },
        {
            path: "purchasing/inventory_receipt/:id?",
            name: "inventory_receipt",
            component: InventoryReceiptsForm,
            meta: {
                requiresAuth: true,
                title: "lang.inventory_receipts",
                restrict_by_login_type: ["employee", "customer"],
                restrict_by_permission: ["inventory_receipts.read"],
            },
        },
        {
            path: "purchasing/purchase_order/:id/inventory_receipt",
            name: "inventory_receipt_po",
            component: InventoryReceiptsForm,
            meta: {
                requiresAuth: true,
                title: "lang.inventory_receipts",
                restrict_by_login_type: ["employee", "customer"],
                restrict_by_permission: ["inventory_receipts.read"],
            },
        },
    ],
};
